// extracted by mini-css-extract-plugin
export default {"container":"NodeIcon_container__wRnGU","icon":"NodeIcon_icon__EmKul"};